t = require('app/scripts/views/internal/teacup-with-helpers')('board_sidebar')

module.exports = t.renderable ->
  t.div '.board-menu-tab-content', ->
    t.div '.board-menu-header.js-board-menu-title', ->
      t.div '.board-menu-header-content', ->

        t.a '.board-menu-header-back-button.icon-lg.icon-back.js-pop-widget-view', { href: '#', title: t.l('go-back') }
        t.h3 '.board-menu-header-title.js-board-menu-title-text'
        t.a '.board-menu-header-close-button.icon-lg.icon-close.js-hide-sidebar', { href: '#', title: t.l('close-the-board-menu') }

      t.hr '.board-menu-header-divider'
    t.div '.board-menu-content.u-fancy-scrollbar.js-board-menu-content-wrapper'